
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.675 2.475h7.65M3.675 9.375h7.65M3.675 5.925h7.65M3.675 12.825h7.65","stroke":"#D2D2D2","stroke-width":".8","stroke-linecap":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.18.45H2.656c-.114 0-.225 0-.318.008a.91.91 0 00-.347.09.9.9 0 00-.393.393.91.91 0 00-.09.347c-.008.093-.008.204-.008.318V2.7h.45V1.62c0-.252 0-.378.05-.474a.45.45 0 01.196-.197C2.292.9 2.418.9 2.67.9h9.51c.252 0 .378 0 .474.049a.45.45 0 01.197.197c.049.096.049.222.049.474v11.91c0 .252 0 .378-.049.474a.45.45 0 01-.197.197c-.096.049-.222.049-.474.049H2.67c-.252 0-.378 0-.474-.05a.45.45 0 01-.197-.196c-.049-.096-.049-.222-.049-.474v-1.08H1.5v1.094c0 .114 0 .224.008.318a.91.91 0 00.09.347.9.9 0 00.393.393.91.91 0 00.347.09c.093.008.204.008.318.008H12.194c.114 0 .224 0 .318-.008a.91.91 0 00.347-.09.9.9 0 00.393-.393.911.911 0 00.09-.347c.008-.094.008-.204.008-.318V1.606c0-.114 0-.225-.008-.318a.91.91 0 00-.09-.347.9.9 0 00-.393-.393.91.91 0 00-.347-.09C12.418.45 12.308.45 12.194.45h-.014z","fill":"#000"}}),_c('path',{attrs:{"d":"M6.3 4.05H.6a.6.6 0 00-.6.6v5.7a.6.6 0 00.6.6h5.7a.6.6 0 00.6-.6v-5.7a.6.6 0 00-.6-.6z","fill":"#000"}}),_c('path',{attrs:{"d":"M5.997 5.85L4.874 9.21H4.37l-.917-2.683-.916 2.683h-.514L.9 5.85h.494l.907 2.731.946-2.731h.442l.926 2.746.926-2.746h.456z","fill":"#fff"}})])
          )
        }
      }
    